module.exports = __webpack_public_path__ + "static/landing_phone_mobile-0a4fdcf3d5e6d294ceadcf903375bfea.jpg";